import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { FederatedSearch } from '@/components/FederatedSearch';

export function SearchTrigger() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      <div className="relative flex-1 max-w-md">
        <Button
          variant="outline"
          className="w-full justify-start text-muted-foreground"
          onClick={() => setIsSearchOpen(true)}
        >
          <Search className="h-4 w-4 mr-2" />
          Search everything...
        </Button>
      </div>
      <FederatedSearch isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
}